// extracted by mini-css-extract-plugin
var _1 = "TaskActionsPopup_icon__uFcxn";
export { _1 as "icon" }
